import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { SmartAlertsApi, } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/smart-alerts/smart-alerts-api';
import { UnreadCountResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/smart-alerts/unread-count.response';
import { BellIconComponent } from '../../../@icons/bell-icon.component';
import { ChevronRightIconComponent } from '../../../@icons/chevron-right.component';
import { HexToHsl } from '../../../@commons/pipes/HexToHsl';

@Component({
    selector: 'vw-alerts-banner',
    imports: [
    TranslatePipe,
    BellIconComponent,
    ChevronRightIconComponent,
    HexToHsl
],
    providers: [
        { provide: SmartAlertsApi, useClass: SmartAlertsApi },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './alerts-banner.component.html',
})
export class AlertsBannerComponent implements OnInit {
    @Output() bannerClick = new EventEmitter<void>();

    unreadCount: UnreadCountResponse | null = null;
    isLoaded = false;

    constructor(private readonly smartAlertsApi: SmartAlertsApi) {}

    async ngOnInit() {
        try {
            this.unreadCount = await this.smartAlertsApi.getUnreadCount();
        } catch (e) {
            // Silently fail — don't show banner if API not available
        }
        this.isLoaded = true;
    }

    get hasAlerts(): boolean {
        return this.urgentCount > 0;
    }

    get urgentCount(): number {
        if (!this.unreadCount?.bySeverity) return 0;
        return (this.unreadCount.bySeverity['CRITICAL'] || 0) + (this.unreadCount.bySeverity['WARNING'] || 0);
    }

    get backgroundColor(): string {
        if (!this.unreadCount?.bySeverity) return '#DAF2E0';
        if (this.unreadCount.bySeverity['CRITICAL'] > 0) return '#FDE2E1';
        if (this.unreadCount.bySeverity['WARNING'] > 0) return '#FFF3CD';
        return '#DAF2E0';
    }

    get textColor(): string {
        if (!this.unreadCount?.bySeverity) return '#093935';
        if (this.unreadCount.bySeverity['CRITICAL'] > 0) return '#7F1D1D';
        if (this.unreadCount.bySeverity['WARNING'] > 0) return '#78350F';
        return '#093935';
    }

    onClick() {
        this.bannerClick.emit();
    }
}
